/**
 * Hooks - Central export for all hooks
 *
 * Hooks are organized by feature in features/{feature}/hooks/
 * Shared hooks are in hooks/shared/
 */

// Auth hooks
export * from "./auth";
export { usePreventInitialInputFocus } from "./usePreventInitialInputFocus";
// Shared hooks
export * from "./shared";

// Contact hooks moved to @/features/contact/hooks

// Feature hooks
export * from "@/features/appointments/hooks";
export * from "@/features/balance/hooks";
export * from "@/features/classes/hooks";
export * from "@/features/dashboard/hooks/useTenantDashboardWidgets";
export * from "@/features/dashboard/hooks/useTeacherClassEnrollments";
export * from "@/features/dashboard/hooks/useStudioDashboardWidgetData";
export * from "@/features/dashboard/hooks/useStudioEnrollmentWidgetsData";
export * from "@/features/dashboard/hooks/useScheduledDropEnrollmentsWidget";
export * from "@/features/user-tasks/hooks";
export * from "@/features/dashboard/hooks/useStudioFeatureSettings";
export * from "@/features/dashboard/hooks/useStudioOperationsSettings";
export * from "@/features/discounts/hooks";
export * from "@/features/employees/hooks";
export * from "@/features/enrollments/hooks";
export * from "@/features/locations/hooks";
export * from "@/features/notifications/hooks";
export * from "@/features/makeups/hooks";
export * from "@/features/parents/hooks";
export * from "@/features/policies/hooks";
export * from "@/features/profile-settings/hooks";
export * from "@/features/seasons/hooks";
export * from "@/features/students/hooks";
export * from "@/features/tasks/hooks";
export * from "@/features/tuition-rates/hooks";
